<template>
  <base-card>
    <base-card-body class="flex flex-col gap-3">
      <h2 class="text-lg">
        {{ healthcenterCount }} {{ $filters.pluralize('pharmacie', healthcenterCount) }}
        {{ $filters.pluralize('partenaire', healthcenterCount) }}
      </h2>
      <healthcenter-group-healthcenter-row
        v-for="healthcenter in healthcenters"
        :key="healthcenter.id"
        :grouping-group="groupId === 0"
        :healthcenter="healthcenter"
        :owner-access-id="ownerAccessId"
        :group-id="groupId"
        @member-deleted="(healthcenterId) => onDelete(healthcenterId)"
      />
    </base-card-body>
  </base-card>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {HealthcenterGroupMember} from "@/disruption-logistics/interfaces/healthcenter-groups";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import HealthcenterGroupHealthcenterRow
    from "@/disruption-logistics/components/healthcenter-groups/HealthcenterGroupHealthcenterRow.vue";

const props = defineProps<{ownerAccessId: number, groupId: number, healthcenters: HealthcenterGroupMember[]}>();
const emits = defineEmits(['member-deleted']);

/**
 * Get the healthcenter count.
 */
const healthcenterCount = computed(() => {
    return props.healthcenters.length;
});

/**
 * Delete an healthcenter from the group.
 */
const onDelete = (healthcenterId: number) => {
    if (props.groupId !== 0) {
        emits('member-deleted', healthcenterId);
    }
};
</script>
